import React from "react";
import "../Loading.css";


const Loading = () => {
  return (
    <div className="spinner-container">
      {/* <img className="loading-spinner" src="/Loader-Patient-App.gif"/> */}
    <div className="spinner"></div>


    </div>



  );
}
export default Loading;